import { Error } from '@mui/icons-material'
import { Chip, ChipProps } from '@mui/material'
import { useMemo } from 'react'
import { LogLevel } from '../../../api/DTO'

type LogLevelChipProps = {
	logLevel: LogLevel
}

const getLogLevelLabel = (logLevel: LogLevel) => {
	switch (logLevel) {
		case LogLevel.Trace:
			return 'Trace'
		case LogLevel.Debug:
			return 'Debug'
		case LogLevel.Information:
			return 'Information'
		case LogLevel.Warning:
			return 'Warning'
		case LogLevel.Error:
			return 'Error'
		case LogLevel.Critical:
			return 'Critical'
		default:
			return logLevel.toString()
	}
}

export const LogLevelChip = ({ logLevel }: LogLevelChipProps) => {
	const color = useMemo<ChipProps['color']>(() => {
		switch (logLevel) {
			case LogLevel.Trace:
				return 'info'
			case LogLevel.Debug:
				return 'primary'
			case LogLevel.Information:
				return 'success'
			case LogLevel.Warning:
				return 'warning'
			case LogLevel.Error:
				return 'error'
			case LogLevel.Critical:
				return 'error'
			default:
				return 'default'
		}
	}, [])

	return (
		<Chip
			label={getLogLevelLabel(logLevel)}
			color={color}
			icon={logLevel === LogLevel.Critical ? <Error /> : undefined}
		/>
	)
}
